export default __webpack_public_path__ + "static/media/logo.b2384fc2.svg";